<template>
  <router-view />
</template>

<script>
export default {
  name: 'WrNotaryCertificate'
};
</script>
